import { render } from "./Box.vue?vue&type=template&id=3561ca77&scoped=true"
import script from "./Box.vue?vue&type=script&lang=js"
export * from "./Box.vue?vue&type=script&lang=js"

import "./Box.vue?vue&type=style&index=0&id=3561ca77&lang=scss&scoped=true"

import exportComponent from "../../../../../SINTEZ/store/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3561ca77"]])

export default __exports__